/**
 * Usage:
 *
 * <button class="load-more js--load-more" data-ajax-url="URL_TO_QUERY" data-target-container="CONTAINER_ELEMENT_ID" data-template="MUSTACHE_TEMPLATE_SCRIPT_ID">Load more</button>
 * <script id="MUSTACHE_TEMPLATE_SCRIPT_ID" type="x-tmpl-mustache"><p>{{title}}</p></script>
 * <div id="CONTAINER_ELEMENT_ID">Will be appended here</div>
 */

import Mustache from 'mustache';

const loadMore = {

  /**
   *
   * @param {DOMelement} btn - Button that triggered lazyload
   */
  load(btn) {
    const self = this;
    const targetElement = document.getElementById(btn.dataset.targetContainer);
    const templateElement = document.getElementById(btn.dataset.template);
    const url = btn.dataset.ajaxUrl;

    this.toggleBtnState(btn, 'loading');

    if(targetElement && templateElement && url) {
      const template = templateElement.innerHTML;

      fetch(url)
        .then(response => response.json())
        .then(data => {
          // Add new items to list
          let markup = '';

          data.items.forEach(item => {
            markup += Mustache.render(template, item);
          });

          targetElement.insertAdjacentHTML('beforeend', markup);

          // Update button
          if(!data.nextPage) {
            // No more results
            self.toggleBtnState(btn, 'done');
          } else {
            // Update button next page url
            btn.dataset.ajaxUrl = data.nextPage;
            self.toggleBtnState(btn, 'idle');
          }
        });
    }
  },

  toggleBtnState(btn, state) {
    if(state === 'loading') {
      // Currently fetching new results
      btn.classList.add('load-more--loading');
      btn.disabled = true;
    } else if(state === 'done') {
      // Done = no more results to load
      btn.classList.remove('load-more--loading');
      btn.classList.add('load-more--done');
      btn.disabled = true;
    } else if(state === 'idle') {
      // Default
      btn.classList.remove('load-more--loading');
      btn.disabled = false;
    }
  },

  init() {
    const self = this;
    // Attach event listeners
    document.addEventListener('click', function(event) {
      if(event.target.matches('.js--load-more')) {
        self.load(event.target);
      }
    });
  }
};

export default loadMore;
